import apiClient from './axios';

export interface Notification {
    id: string;
    title: string;
    message: string;
    channels: string; // JSON
    recipient?: string;
    priority: 'Low' | 'Normal' | 'High' | 'Critical';
    createdAt: string;
    processedAt?: string;
    error?: string;
}

export const notificationsApi = {
    getNotifications: async (params: { pageNumber: number; pageSize: number }) => {
        const response = await apiClient.get('/admin/notifications', { params });
        return response.data;
    },
    retryNotification: async (id: string) => {
        const response = await apiClient.post(`/admin/notifications/${id}/retry`);
        return response.data;
    },
    deleteNotification: async (id: string) => {
        const response = await apiClient.delete(`/admin/notifications/${id}`);
        return response.data;
    }
};
